import { Navigate, Route, Routes } from "react-router-dom";
import Cadastro from "../pages/Cadastro";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";

const RoutesMain = () => {
    return(
            <Routes>
                <Route path='/' element={<Login />} />
                <Route path='/dashboard' element={<Dashboard/>} />
                <Route path='/cadastro' element={<Cadastro />} />
                <Route path="*" element={<Navigate replace to='/'/>}/>
            </Routes>
    )
}

export default RoutesMain;